export function dateFormat(date) {
  let dateTransform = new Date(date).toISOString().split("T");
  dateTransform[0] = dateTransform[0].replace(/-/g, "/");
  dateTransform[1] = dateTransform[1].slice(0, 5).replace(":", "h");

  return dateTransform[0] + " (" + dateTransform[1] + ")";
}



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js